import { useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { analyticsWorkspace } from '../services/api';

const SCOPE_KEYS = ['labId', 'term', 'courseCode', 'from', 'to'];

export default function useAnalyticsData(resource, params, enabled = true) {
  const { user } = useAuth();
  const actor = user?._id || user?.id;
  const role = user?.role;
  const forceNext = useRef(false);
  const query = useQuery({
    queryKey: ['analytics-workspace', actor, role, resource, params],
    queryFn: ({ signal }) => {
      const fresh = forceNext.current;
      forceNext.current = false;
      return analyticsWorkspace.get(resource, { ...params, ...(fresh ? { fresh: 'true' } : {}) }, signal);
    },
    enabled: enabled && Boolean(actor),
    staleTime: 60000,
    placeholderData: (previous, previousQuery) => {
      const key = previousQuery?.queryKey;
      // Keep rows while paging within one scope, never across identities,
      // permissions, entities or lab/date filters.
      if (key?.[1] === actor && key[2] === role && key[3] === resource
        && SCOPE_KEYS.every((field) => key[4]?.[field] === params[field])) return previous;
      return undefined;
    },
  });
  return { ...query, refresh: () => { forceNext.current = true; return query.refetch(); } };
}
